export const HolidayInputs = [
  { name: 'name', label: "Name", type: 'text', defaultValue: '', validation: { required: "Please enter a name" } },
  { name: 'date', label: "Date", type: 'date', defaultValue: '', validation: { required: "Please enter a date" } },
  { name: 'sameAsDate', value: true, label: "Observed On Date?", type: 'checkbox' },
  { name: 'observedOn', label: "Observed On", type: 'date', defaultValue: '', validation: { required: "Please enter a date" } },
];